import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModelsService } from 'src/app/views/my-space/my-models/models.service';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Component({
  selector: 'app-model-picker',
  templateUrl: './model-picker.component.html',
  styleUrls: ['./model-picker.component.scss'],
  standalone: false,
})
export class ModelPickerComponent implements OnInit {
  templates = [];
  loading = false;
  searchTerm = '';
  pageSize = 100;
  displayedTemplates = [];
  @Input() templateID;
  currentTemplate;
  selectedTemplates = [];

  constructor(
    private modelService: ModelsService,
    private toast: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getCurrentTemplate();
  }

  getCurrentTemplate() {
    this.loading = true;
    this.modelService.getTemplate(this.templateID).subscribe({
      next: (template) => {
        this.currentTemplate = template;
        this.getTemplates();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  isSelected(id) {
    if (!this.currentTemplate || this.templates.length === 0) {
      return true;
    } else {
      return this.currentTemplate.subTemplates?.find((templateID) => templateID === id);
    }
  }

  getTemplates() {
    this.loading = true;
    this.modelService
      .searchTemplates({
        searchTerm: this.searchTerm,
        pageIndex: 0,
        pageSize: this.pageSize,
      })
      .subscribe({
        next: (res) => {
          this.templates = res.results || [];
          this.filter();
          this.selectedTemplates = this.templates.filter((template) => this.isSelected(template._id));
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
  }

  filter() {
    this.displayedTemplates = this.templates.filter((template) => template.name.includes(this.searchTerm)) || [];
  }

  removeTemplate(templateID) {
    this.modelService
      .removeSubtemplates({
        templateID: this.templateID,
        subTemplateID: templateID,
      })
      .subscribe({
        next: () => {
          this.getCurrentTemplate();
        },
        error: (err) => {
          console.error(err);
          this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
            duration: 2000,
          });
        },
      });
  }

  addTemplate(templateID) {
    this.modelService
      .addSubTemplate({
        templateID: this.templateID,
        subTemplateID: templateID,
      })
      .subscribe({
        next: () => {
          this.getCurrentTemplate();
        },
        error: (err) => {
          console.error(err);
          this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
            duration: 2000,
          });
        },
      });
  }
}
